export enum IconTypes {
  icons = 'icons',
  logos = 'logos',
  feedback = 'feedback',
}

export enum ImageTypes {
  background = 'background',
  feedback = 'feedback',
}

export interface ISvgProps {
  id?: string;
  className?: string;
}
export type IIcons = {
  [key in IconTypes]: { [icon: string]: React.FunctionComponent<ISvgProps> };
};

export type IImg = {
  [key in ImageTypes]: { [key: string]: string };
};

export type Images = IIcons & IImg;
